import auth from "../../api/auth.js";

// initial state
const state = () => ({
  session: null,
});

// getters
const getters = {
  getUsername(state) {
    if (!state.session) return null;
    return state.session.sub;
  },
  getRoles(state) {
    if (!state.session?.roles) return [];
    return state.session.roles
      .split(",")
      .map((role) => role.trim())
      .filter((role) => role.length > 0);
  },
  canManageUsers(state) {
    if (!state.session) return false;
    return state.session.privileges.includes("user_management");
  },
  canManageServer(state) {
    if (!state.session) return false;
    return state.session.privileges.includes("server_management");
  },
  canManageProfile(state) {
    if (!state.session) return false;
    return state.session.privileges.includes("profile_management");
  },
  canAudit(state) {
    if (!state.session) return false;
    return state.session.privileges.includes("auditor");
  },
  canConfigureApplication(state) {
    if (!state.session) return false;
    return state.session.privileges.includes("application_configuration");
  },
  isAuthenticated(state) {
    if (!state.session) return false;
    let timeNow = Math.floor(new Date().getTime() / 1000);
    return timeNow < state.session.exp;
  },
  getExpiry(state) {
    if (!state.session) return 0;
    return state.session.exp;
  },
  requiresPasswordChange(state) {
    return state.session.req_pass_change;
  },
};

// actions
const actions = {
  async login({ commit }, payload) {
    return new Promise((resolve, reject) => {
      auth.login(payload.username, payload.password).then(
        (response) => {
          commit("setSession", response.data.session);
          resolve(response);
        },
        (error) => {
          reject(error);
        },
      );
    });
  },
  async logout({ commit }) {
    commit("clearSession");
  },
};

// mutations
const mutations = {
  setSession(state, session) {
    state.session = session;
  },
  clearSession(state) {
    state.session = null;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
